import React from 'react';
import { Link } from 'react-router-dom'

const NotFound = () => {

  return (
    <section className="section">
      <div className="container">
        <section className="hero has-text-centered">
          <div className="hero-body">
            <div className="container">
              <h1 className="title">
                Page Not Found
              </h1>
              <Link to="create"className="button is-info is-large">Create New</Link> <Link to="notes" className="button is-link is-large">View Previous</Link>
            </div>
          </div>
        </section>
      </div>
    </section>
  )
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/Pages/notfound.js